import VueApollo from 'vue-apollo'
import Vue from 'vue'
import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { WebSocketLink } from 'apollo-link-ws'
import { getMainDefinition } from 'apollo-utilities'
import { HttpLink } from 'apollo-link-http'
import { split } from 'apollo-link'

const hasuraUrl = 'hasura.solestage.mokekeji.com/v1'
let httpUri = `https://${hasuraUrl}/graphql`
let wsUri = `wss://${hasuraUrl}/graphql`

const httpLink = new HttpLink({
  uri: httpUri,
  headers: { // 配置headers
    'x-hasura-admin-secret': 'moke1404' // hasura数据库查看
  }
})

const wsLink = new WebSocketLink({
  uri: wsUri,
  options: {
    lazy: true,
    reconnect: true,
    timeout: 30000,
    connectionParams: { // 配置headers
      headers: {
        'x-hasura-admin-secret': 'moke1404'
      }
    }
  }
})

const link = split(
  ({ query }) => {
    const definition = getMainDefinition(query)
    return definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
  },
  wsLink,
  httpLink
)

const apolloClient = new ApolloClient({
  link: link,
  cache: new InMemoryCache(),
  connectToDevTools: true
})

const hasuraUrlOther = 'hasura.solestage-dev.mokekeji.com/v1'
let httpUriOther = `https://${hasuraUrlOther}/graphql`
let wsUriOther = `wss://${hasuraUrlOther}/graphql`

const httpLinkOther = new HttpLink({
  uri: httpUriOther,
  headers: { // 配置headers
    'x-hasura-admin-secret': 'moke1404' // hasura数据库查看
  }
})

const wsLinkOther = new WebSocketLink({
  uri: wsUriOther,
  options: {
    lazy: true,
    reconnect: true,
    timeout: 30000,
    connectionParams: { // 配置headers
      headers: {
        'x-hasura-admin-secret': 'moke1404'
      }
    }
  }
})

const linkOther = split(
  ({ query }) => {
    const definition = getMainDefinition(query)
    return definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
  },
  wsLinkOther,
  httpLinkOther
)

const apolloClientOther = new ApolloClient({
  link: linkOther,
  cache: new InMemoryCache(),
  connectToDevTools: true
})

Vue.use(VueApollo)

const apolloProvider = new VueApollo({
  clients: {
    onLine: apolloClient,
    // 这个是我设置的默认接口的地址
    dev: apolloClientOther
    // 这是另一部分功能的接口地址，另外这个key名，在页面中写具体请求时会用到，因为我们要指定接口的地址
  },
  defaultClient: apolloClient
})
export default apolloProvider
